import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Appointments from './components/Appointments';
import Doctors from './components/Doctors';
import Patients from './components/Patients';
import Navbar from './components/Navbar';
import Contacts from './components/Contacts';
import { AdminProvider, useAdminContext } from './context/AdminContext';
import './App.css';
import Users from './Users'; // Import komponen Users
import ChangePassword from './components/ChangePassword'; // Import komponen ChangePassword

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { admin } = useAdminContext();
  
  if (!admin) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppContent() {
  const { admin, authChecked } = useAdminContext();
  
  // Add console log to help debug authentication state
  console.log("Admin auth state:", admin, "Auth checked:", authChecked);
  
  // Show loading indicator while checking authentication
  if (!authChecked) {
    return <div className="loading-container">Loading...</div>;
  }
  
  return (
    <Router>
      <div className="App">
        {admin && <Navbar />}
        <div className={`content ${!admin ? 'full-width' : ''}`}>
          <Routes>
            <Route path="/login" element={
              admin ? <Navigate to="/" replace /> : <Login />
            } />
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/appointments" element={
              <ProtectedRoute>
                <Appointments />
              </ProtectedRoute>
            } />
            <Route path="/doctors" element={
              <ProtectedRoute>
                <Doctors />
              </ProtectedRoute>
            } />
            <Route path="/patients" element={
              <ProtectedRoute>
                <Patients />
              </ProtectedRoute>
            } />
            <Route path="/contacts" element={
              <ProtectedRoute>
                <Contacts />
              </ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            } />
            <Route path="/change-password" element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            } />
            {/* Modified catch-all route to be more lenient */}
            <Route path="*" element={
              admin ? <Dashboard /> : <Navigate to="/login" replace />
            } />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

function App() {
  return (
    <AdminProvider>
      <AppContent />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </AdminProvider>
  );
}

export default App;
